<div
  class="bg-white border border-gray-300 rounded-2xl shadow-lg z-50 min-[600px]:!w-[361px] min-[600px]:m-auto"
>
  <div class="bg-neutral-200 p-2 border-b border-gray-200 rounded-t-2xl">
    <h4
      class="text-body-bold text-brand-primary text-center min-[723px]:text-start"
    >
      Notificaciones
    </h4>
  </div>

  <div class="flex flex-row gap-2 justify-center bg-neutral-50">
    <p class="text-body text-brand-primary p-1 text-center">
      Marcar todas como leídas
      <i class="pi pi-check"></i>
    </p>
  </div>

  <div class="max-h-64 overflow-y-auto rounded-b-2xl">
    <div class="relative">
      <i
        class="absolute top-4 right-2 pi pi-times text-neutral-500 cursor-pointer"
      ></i>
      <div
        class="flex flex-col gap-1 border-y-[1px] border-l-2 border-l-transparent bg-neutral-50 py-4 px-2 pr-10 hover:bg-sky-50 hover:border-l-blue-500 transition-colors hover:shadow"
      >
        <p class="text-body-bold text-gray-900">
          <i class="pi pi-comment text-neutral-500 mr-2"></i>
          <span>Mensaje nuevo:</span>
        </p>
        <p class="text-gray-700 text-body ml-6">
          Luisa Fernanda Carvajal (Consultor) te dejó un mensaje en la
          declaración:
        </p>
        <p class="text-blue-500 text-body ml-6">2023-1 Actualización Anual</p>
        <p class="text-gray-500 text-label ml-6">Fecha: 5 sep 2023</p>
      </div>
    </div>

    <div class="relative">
      <i
        class="absolute top-4 right-2 pi pi-times text-neutral-500 cursor-pointer"
      ></i>
      <div
        class="flex flex-col gap-1 border-y-[1px] border-l-2 border-l-transparent bg-neutral-50 py-4 px-2 pr-10 hover:bg-sky-50 hover:border-l-blue-500 transition-colors hover:shadow"
      >
        <p class="text-body-bold text-gray-900">
          <i class="pi pi-bell text-neutral-500 mr-2"></i>
          <span>Transferencia:</span>
        </p>
        <p class="text-gray-700 text-body ml-6">
          Juan Camilo Zapata (Revisor) te transfirió la siguiente declaración:
        </p>
        <p class="text-blue-500 text-body ml-6">2023-1 Actualización Anual</p>
        <p class="text-gray-500 text-label ml-6">Fecha: 5 sep 2023</p>
      </div>
    </div>
  </div>
</div>
